import { intendedRoute, useAuth } from '@/lib/auth/auth-context';
import { Navigate } from 'react-router-dom';
import { Button, Column, Grid, Tile, Loading } from '@carbon/react';
import { Login } from '@carbon/icons-react';

/**
 * Sign-in page. The button starts an authorization-code + PKCE flow against the
 * Keycloak realm; the tokens it brings back live in memory only.
 */
export function AuthPage() {
  const { isAuthenticated, isLoading, login, isAuthUnavailable } = useAuth();

  if (isLoading) {
    return (
      <Grid fullWidth className="auth-page">
        <Column lg={16} md={8} sm={4}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Loading withOverlay={false} description="Checking authentication..." />
          </div>
        </Column>
      </Grid>
    );
  }

  if (isAuthenticated) {
    // THE LAST PLACE THE DEEP LINK DIED, and the one that made the previous two fixes look useless.
    //
    // Measured 2026-08-19: with the guard now carrying `/auth?returnTo=/editor`, the silent sign-in
    // completed, the callback sent the browser to /editor... and an already-authenticated visitor
    // passing through /auth was bounced to "/" from here, hard-coded. A route is only restored if EVERY
    // hop on the way agrees to carry it: the guard, the failed silent attempt, the interactive login,
    // and this one.
    return <Navigate to={intendedRoute()} replace />;
  }

  return (
    <Grid fullWidth className="auth-page">
      <Column lg={{ span: 6, offset: 5 }} md={{ span: 6, offset: 1 }} sm={4}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: '2rem' }}>
          <Tile style={{ width: '100%', maxWidth: '480px', padding: '2.5rem', textAlign: 'center' }}>
            <div style={{ marginBottom: '2rem' }}>
              <h1 style={{ fontSize: '1.75rem', fontWeight: 600, marginBottom: '0.5rem' }}>
                IBM Science Studio
              </h1>
              <p style={{ color: 'var(--cds-text-secondary)', fontSize: '0.875rem' }}>
                Sign in with your IBM Science Studio account to continue
              </p>
            </div>

            <Button
              size="lg"
              onClick={login}
              renderIcon={Login}
              disabled={isAuthUnavailable}
              style={{ width: '100%', maxWidth: '320px' }}
            >
              Sign in
            </Button>

            <p style={{ marginTop: '1.5rem', fontSize: '0.75rem', color: 'var(--cds-text-helper)' }}>
              {isAuthUnavailable
                ? 'Sign-in is not configured on this deployment (VITE_KEYCLOAK_ISSUER is empty).'
                : 'You will be redirected to the IBM Science Studio identity provider (Keycloak) for authentication.'}
            </p>
          </Tile>
        </div>
      </Column>
    </Grid>
  );
}

// Made with Bob
